import { useState } from "react";

import { Button } from "@/components/button";
import { Label } from "@/components/field";

import type { BrandSelectData } from "../../types/mbc-chat.types";

type BrandSelectPartProps = {
  brandSelect: BrandSelectData;
  isDisabled: boolean;
  onSelect: (label: string) => void;
};

export function BrandSelectPart({
  brandSelect,
  isDisabled,
  onSelect,
}: BrandSelectPartProps) {
  const [selectedBrandId, setSelectedBrandId] = useState<string>("");

  const selectedBrand = brandSelect.brands.find(
    (brand) => String(brand.id) === selectedBrandId,
  );

  return (
    <div className="mt-md flex flex-col gap-sm rounded-xl border border-border-secondary bg-bg-primary p-md">
      <Label>Select brand</Label>
      <select
        className="rounded-lg border border-border-primary bg-bg-primary px-md py-sm text-sm text-text-primary outline-none"
        disabled={isDisabled}
        onChange={(event) => setSelectedBrandId(event.target.value)}
        value={selectedBrandId}
      >
        <option value="">Choose a brand...</option>
        {brandSelect.brands.map((brand) => (
          <option key={brand.id} value={brand.id}>
            {brand.name}
          </option>
        ))}
      </select>
      <Button
        className="self-start"
        isDisabled={isDisabled || !selectedBrand}
        onPress={() => {
          if (selectedBrand) onSelect(selectedBrand.name);
        }}
        size="sm"
        variant="primary"
      >
        Confirm brand
      </Button>
    </div>
  );
}
